import {Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-step-buttons',
  templateUrl: './step-buttons.component.html',
  styleUrls: ['./step-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepButtonsComponent implements OnInit {

  @Input()
  leftButtonLabel = '';
  @Input()
  rightButtonLabel = '';
  @Output()
  public leftClicked = new EventEmitter<any>();
  @Output()
  public rightClicked = new EventEmitter<any>();


  constructor() { }

  ngOnInit(): void {
  }

  buttonLeftClicked() {
    this.leftClicked.emit();
  }

  buttonRightClicked() {
    this.rightClicked.emit();
  }

}
